import {useLocalStorage} from '@wandb/weave/util/useLocalStorage';

export const useShowMarkdownInChatView = () => {
  const [showMarkdownInChatView, setShowMarkdownInChatView] = useLocalStorage(
    'showMarkdownInChatView',
    true
  );
  return {showMarkdownInChatView, setShowMarkdownInChatView};
};
